import { tickerItems } from "@/mocks/home";

export default function UpdateTicker() {
  const loop = [...tickerItems, ...tickerItems];

  return (
    <div className="w-full bg-foreground-950 text-background-50">
      <div className="mx-auto flex max-w-[1400px] items-center gap-3 px-4 md:px-6">
        <span className="flex shrink-0 items-center gap-2 py-2.5 text-[11px] tracking-[0.18em] text-accent-300">
          <span className="relative flex h-2 w-2">
            <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-accent-400 opacity-70" />
            <span className="relative inline-flex h-2 w-2 rounded-full bg-accent-500" />
          </span>
          实时更新
        </span>
        <span className="h-4 w-px shrink-0 bg-background-800" />
        <div className="relative flex-1 overflow-hidden py-2.5">
          <div className="flex w-max animate-ticker items-center gap-10 whitespace-nowrap">
            {loop.map((item, index) => (
              <span
                key={`ticker-${index}`}
                className="flex items-center gap-2 text-[11px] text-background-300 md:text-xs"
              >
                <span className="font-label text-primary-300">{item.time}</span>
                <span>{item.text}</span>
                <span className="text-background-700">/</span>
              </span>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}